import { render, staticRenderFns } from "./RcWidgetLiveResultsHouseMidwest.vue?vue&type=template&id=2bbb6f58&"
import script from "./RcWidgetLiveResultsHouseMidwest.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsHouseMidwest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports